// extracted by mini-css-extract-plugin
export default {"flagButton":"LangMenu_flagButton__J57HK","flagContainer":"LangMenu_flagContainer__gX8v6","languagesList":"LangMenu_languagesList__4-ikd","show_menu":"LangMenu_show_menu__ubYaK"};